export const GET_DATA_RETENTION_SETTINGS = 'GET_DATA_RETENTION_SETTINGS';
export const GET_DATA_RETENTION_SETTINGS_SUCCESS = 'GET_DATA_RETENTION_SETTINGS_SUCCESS';
export const GET_DATA_RETENTION_SETTINGS_ERROR = 'GET_DATA_RETENTION_SETTINGS_ERROR';
